import React from 'react';
import Link from 'next/link';
import {MUIBox} from '@/components/MUI-Components';
import {colors, fontFamily, fontSize, fontWeight} from '@/styles/tokens';

// Per-element sx constants driven by tokens.ts (no nested class selectors). The
// 600px responsive step uses MUI breakpoint keys (xs = below sm/600, sm = 600+),
// which is mobile-first: xs holds the small value, sm restores the desktop value.
const sxBreadcrumb = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '6px',
    mb: '28px',
    fontFamily: fontFamily.body,
    fontSize: {xs: fontSize[12], sm: fontSize[14]},
    color: colors.text.secondary
} as const;

const sxLink = {
    color: colors.text.secondary,
    textDecoration: 'none',
    transition: 'color 0.2s',
    '&:hover': {color: colors.primary.main}
} as const;

const sxSep = {color: colors.text.muted} as const;

const sxCurrent = {
    color: colors.text.primary,
    fontWeight: fontWeight.medium,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: {xs: '200px', sm: '360px'}
} as const;

// `basePath`/`sectionLabel` default to the blog so existing call sites are unchanged;
// the use-case detail page passes '/use-cases' + 'Use Cases'.
const BlogBreadcrumb = ({
    blogCategoryName,
    basePath = '/blog',
    sectionLabel = 'Blog'
}: {
    blogCategoryName: string;
    basePath?: string;
    sectionLabel?: string;
}) => (
    <MUIBox component="nav" sx={sxBreadcrumb} aria-label="breadcrumb">
        <MUIBox component={Link} href="/" sx={sxLink}>
            Home
        </MUIBox>
        <MUIBox component="span" sx={sxSep}>
            /
        </MUIBox>
        <MUIBox component={Link} href={basePath} sx={sxLink}>
            {sectionLabel}
        </MUIBox>
        {blogCategoryName && (
            <>
                <MUIBox component="span" sx={sxSep}>
                    /
                </MUIBox>
                <MUIBox component="span" sx={sxCurrent}>
                    {blogCategoryName}
                </MUIBox>
            </>
        )}
    </MUIBox>
);

export default BlogBreadcrumb;
